function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 0A6 6 0 00.73 8.872l-.71 2.49a.5.5 0 00.638.612l2.338-.779A6 6 0 106 0zM4 5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3A.5.5 0 014 5zm.5 1.5h2a.5.5 0 010 1h-2a.5.5 0 010-1z",
  fill: "#8F90A6"
});

function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgComments;